exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formline[data-v-8f66385a] {\n  padding: 15px 10px;\n}\n", ""]);

// exports
